const Accordion = {
  init: () => {
    const accordionElements = document.querySelectorAll('.js-accordion');
    const mobileOnlyAccordion = document.querySelectorAll('.js-accordion-mobile-only');

    mobileOnlyAccordion?.forEach((mobileAccordionElement: HTMLElement) => {
      const toggleButtonElement: HTMLElement =
        mobileAccordionElement.querySelector('[aria-expanded]');
      const contentElement: HTMLElement = mobileAccordionElement.querySelector('[aria-hidden]');

      if (!(window.screen.width <= 768)) {
        contentElement.setAttribute('aria-hidden', 'false');
        toggleButtonElement.setAttribute('aria-expanded', 'true');
        toggleButtonElement.setAttribute('disabled', 'true');
      } else {
        contentElement.setAttribute('aria-hidden', 'true');
      }
      const links = contentElement?.querySelectorAll('a');
      links.forEach((link) => {
        if (!(window.screen.width <= 768)) {
          link.setAttribute('aria-hidden', 'false');
          link.setAttribute('tabindex', '0');
        }
      });

      function resizeWindow() {
        if (!(window.screen.width <= 768)) {
          contentElement.setAttribute('aria-hidden', 'false');
          toggleButtonElement.setAttribute('aria-expanded', 'true');
          toggleButtonElement.setAttribute('disabled', 'true');
        } else {
          contentElement.setAttribute('aria-hidden', 'true');
          toggleButtonElement.setAttribute('aria-expanded', 'false');
          toggleButtonElement.removeAttribute('disabled');
        }

        links.forEach((link) => {
          if (!(window.screen.width <= 768)) {
            link.setAttribute('aria-hidden', 'false');
            link.setAttribute('tabindex', '0');
          } else {
            link.setAttribute('aria-hidden', 'true');
            link.setAttribute('tabindex', '1');
          }
        });
      }

      function toggleMobileContent() {
        const expanded = toggleButtonElement.getAttribute('aria-expanded') === 'true';
        const nextExpandedState = !expanded;
        toggleButtonElement.setAttribute('aria-expanded', `${nextExpandedState}`);
        contentElement.setAttribute('aria-hidden', `${!nextExpandedState}`);

        links.forEach((link) => {
          link.setAttribute('aria-hidden', `${!nextExpandedState}`);
          link.setAttribute('tabindex', `${nextExpandedState ? 0 : -1}`);
        });
      }
      const screenwidth = window.screen.width;
      window.addEventListener('resize', function () {
        // prevent resize event triggering on mobile scroll
        if (screenwidth !== window.screen.width) {
          resizeWindow();
        }
      });

      toggleButtonElement.addEventListener('click', toggleMobileContent);
    });

    accordionElements?.forEach((accordionElement: HTMLElement) => {
      const toggleButtonElement: HTMLElement = accordionElement.querySelector('[aria-expanded]');
      const contentElement: HTMLElement = accordionElement.querySelector('[aria-hidden]');

      const links = contentElement?.querySelectorAll('a');

      function toggleContent() {
        const expanded = toggleButtonElement.getAttribute('aria-expanded') === 'true';
        const nextExpandedState = !expanded;
        toggleButtonElement.setAttribute('aria-expanded', `${nextExpandedState}`);
        contentElement.setAttribute('aria-hidden', `${!nextExpandedState}`);

        // improve a11y and update the link state according the accordion state
        // @see app/profiles/contrib/social/modules/social_features/social_core/assets/js/accessibility.js
        links.forEach((link) => {
          link.setAttribute('aria-hidden', `${!nextExpandedState}`);
          link.setAttribute('tabindex', `${nextExpandedState ? 0 : -1}`);
        });
      }
      toggleButtonElement.addEventListener('click', toggleContent);
    });
  },
};

export default Accordion;
